// Import Dependencies
import React from 'react';
import { observer, inject } from 'mobx-react';

import AccountModal from '~/common/components/AccountModal';
import CommonButton from '~/common/components/CommonButton';

import { MODAL_ACCOUNT } from '~/common/utils/consts.js';

// Import Stylesheet
import styles from './modal.css';

// components to render in modal
const modalChildComponents = {
    [MODAL_ACCOUNT]: <AccountModal />
};

@inject('modalStore')
@observer
export default class Modal extends React.Component {
    renderChildModal() {
        const { childComponentString } = this.props.modalStore;
        // if there is a subroute that matches return subroute component
        return modalChildComponents[childComponentString] ? modalChildComponents[childComponentString] : null;
    }

    closeModal() {
        const { modalStore } = this.props;
        // if modal is closable, close it.
        if (modalStore.isModalClosable) modalStore.setModalOptions({ isModalOpen: false });
    }

    render() {
        // boolean denoting if modal is able to be close, and if modal is supposed to be shown
        const { isModalClosable, isModalOpen, modalType, transparent } = this.props.modalStore;
        // if modal is set to be open
        if (isModalOpen) {
            return (
                <div className={`${styles.blocker} ${transparent ? styles.transparent : ''}`} onClick={() => this.closeModal()}>
                    <div className={`${styles.modal} ${styles[modalType]}`}>
                        {this.renderChildModal()}
                        {isModalClosable &&
                            <CommonButton
                                arrow={false}
                                id="close__button"
                                modifier={styles.button}
                                onClick={() => this.closeModal()}
                            >Close</CommonButton>}
                    </div>
                </div>
            );
        }
        // otherwise render nothing
        return null;
    }
}
